import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { services } from '@/data/services';
import type { City } from '@/data/cities';

interface Props { city: City }

const VilleServices = ({ city }: Props) => (
  <section className="py-16 md:py-20 px-6 lg:px-8 bg-muted/20">
    <div className="max-w-6xl mx-auto">
      <p className="text-xs font-heading font-semibold uppercase tracking-[0.15em] text-primary mb-2 text-center">Nos prestations</p>
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-4 text-center">
        Nos services disponibles depuis {city.name}
      </h2>
      <p className="text-muted-foreground text-center max-w-2xl mx-auto mb-12 text-sm">
        Que vous recherchiez un wedding planner {city.prefix} {city.name}, un DJ ou des animations pour enfants, Cygnature Production met à votre disposition des prestations sur-mesure.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((service) => {
          const Icon = service.icon;
          return (
            <Link
              key={service.slug}
              to={`/services/${service.slug}`}
              onClick={() => window.scrollTo(0, 0)}
              className="relative block p-6 rounded-2xl border border-border bg-card hover:shadow-lg hover:border-primary/20 transition-all group overflow-hidden"
            >
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-primary/60 to-accent opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/10 flex items-center justify-center mb-5 group-hover:from-primary/25 group-hover:to-primary/10 transition-all">
                <Icon size={22} className="text-primary" strokeWidth={1.5} />
              </div>
              <h3 className="font-heading font-bold text-foreground mb-2">{service.title}</h3>
              <p className="text-sm text-muted-foreground line-clamp-2 mb-4">{service.shortDesc}</p>
              <span className="inline-flex items-center gap-1 text-primary text-sm font-heading font-medium group-hover:gap-2 transition-all">
                Découvrir <ArrowRight size={14} />
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  </section>
);

export default VilleServices;
